import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const FC_CATALOGS = generateUrl()

const catalogsApiInstance = axios.create({
    baseURL: `${FC_CATALOGS}/fc-dr-catalogs/api/v1`
})

catalogsApiInstance.interceptors.request.use(onRequestSuccess, undefined)
catalogsApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default catalogsApiInstance
